// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"744":"60da4df77bf83247","2760":"0512cb0e312d6064","3185":"c07266b931ee2839","8858":"9dbff2e13711323a"}[chunkId] + ".css";
};